import { Validators } from '@angular/forms';

export class AutoCollateralModel {
    vehicle = {
        value: {},
        validation: Validators.compose([])
    };
    vin = {
        value: null,
        validation: Validators.compose([])
    };
}
